<template>
  <el-card class="h-full" :body-style="{ height: '100%', overflow: 'auto' }">
    <div class="flex items-center">
      <span class="border-l-3 border-color-primary flex-1 pl-10px text-18px">稿费标准管理</span>
    </div>
    <div class="w-full mt-20px">
      <el-button v-if="canEdit === true" size="small" type="primary" @click="isEdit">
        编辑
      </el-button>
      <el-button v-if="canEdit === false" size="small" type="primary" @click="addData">
        新增行数
      </el-button>
    </div>
    <div class="w-full mt-20px">
      <el-table :data="tableData" v-loading="tableLoading" ref="table" border>
        <el-table-column type="index" align="center" label="序号" width="50" />
        <el-table-column align="left" header-align="center" prop="categoryId" label="稿件类别">
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.categoryId"
              :disabled="canEdit"
              placeholder="请选择稿件类别"
            >
              <el-option
                v-for="item in royaltiesCategory"
                :key="item.id"
                :label="item.displayName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column align="left" header-align="center" prop="typeId" label="稿件类型">
          <template slot-scope="scope">
            <el-select v-model="scope.row.typeId" :disabled="canEdit" placeholder="请选择稿件类型">
              <el-option
                v-for="item in royaltiesType"
                :key="item.id"
                :label="item.displayName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          align="left"
          header-align="center"
          prop="companyLevel"
          label="公司级（元/篇）"
        >
          <template slot-scope="scope">
            <div
              class="wrap"
              :contenteditable="!canEdit"
              @blur="lossFocus($event, scope, 'companyLevel')"
              @focus="getFocus($event, scope.row, 'companyLevel')"
              v-text="scope.row.companyLevel"
            ></div>
          </template>
        </el-table-column>
        <el-table-column
          align="left"
          header-align="center"
          prop="provinceLevel"
          label="广东级（元/篇）"
        >
          <template slot-scope="scope">
            <div
              class="wrap"
              :contenteditable="!canEdit"
              @blur="lossFocus($event, scope, 'provinceLevel')"
              @focus="getFocus($event, scope.row, 'provinceLevel')"
              v-text="scope.row.provinceLevel"
            ></div>
          </template>
        </el-table-column>
        <el-table-column
          align="left"
          header-align="center"
          prop="groupLevel"
          label="集团级（元/篇）"
        >
          <template slot-scope="scope">
            <div
              class="wrap"
              :contenteditable="!canEdit"
              @blur="lossFocus($event, scope, 'groupLevel')"
              @focus="getFocus($event, scope.row, 'groupLevel')"
              v-text="scope.row.groupLevel"
            ></div>
          </template>
        </el-table-column>
        <el-table-column
          align="left"
          header-align="center"
          prop="withImage"
          label="配照片（元/篇）"
        >
          <template slot-scope="scope">
            <div
              class="wrap"
              :contenteditable="!canEdit"
              @blur="lossFocus($event, scope, 'withImage')"
              @focus="getFocus($event, scope.row, 'withImage')"
              v-text="scope.row.withImage"
            ></div>
          </template>
        </el-table-column>
        <el-table-column align="left" header-align="center" prop="remark" label="备注">
          <template slot-scope="scope">
            <div
              class="wrap"
              :contenteditable="!canEdit"
              @blur="lossFocus($event, scope, 'remark')"
              @focus="getFocus($event, scope.row, 'remark')"
              v-text="scope.row.remark"
            ></div>
          </template>
        </el-table-column>
        <el-table-column align="center" width="200" v-if="!canEdit">
          <template slot="header">
            <p>操作</p>
          </template>
          <template slot-scope="scope">
            <el-button
              :disabled="canEdit"
              size="mini"
              @click="removeRow(scope.$index, tableData, scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="w-full fixed bottom-20px left-1/2">
      <el-button v-if="canEdit === false" size="small" type="primary" @click="submit">
        保存
      </el-button>
      <el-button v-if="canEdit === false" size="small" @click="cancel">
        取消
      </el-button>
    </div>
  </el-card>
</template>

<script>
import { RoyaltiesStandardApi } from '@wiz-api/workbench'
import { DataCategoryApi } from '@wiz-api/data-category-management'

const royaltiesStandardApi = new RoyaltiesStandardApi()
const dataCategoryApi = new DataCategoryApi()

export default {
  data() {
    return {
      canEdit: true,
      tableData: [],
      tableLoading: false,
      royaltiesCategory: [],
      royaltiesType: [],
      deleteList: [],
    }
  },
  mounted() {
    this.getTableData()
    this.dataCategoryApi()
  },
  methods: {
    async dataCategoryApi() {
      const param = {
        code: 'RoyaltiesCategory',
        includeDetails: true,
      }
      const [err, res] = await dataCategoryApi.getByCode(param)
      if (!err && res) {
        this.royaltiesCategory = res.dataItems
      }
      const params = {
        code: 'RoyaltiesType',
        includeDetails: true,
      }
      const [errType, resType] = await dataCategoryApi.getByCode(params)
      if (!errType && resType) {
        this.royaltiesType = resType.dataItems
      }
    },
    async getTableData() {
      this.tableLoading = true
      const [err, res] = await royaltiesStandardApi.getRoyaltiesStandard()
      if (!err && res) {
        this.tableData = res
      }
      this.tableLoading = false
    },
    lossFocus(e, scope, type) {
      const content = _.trim(e.target.textContent)
      const reg = /^[1-9]\d*$/g
      if (
        (type === 'companyLevel' ||
          type === 'provinceLevel' ||
          type === 'groupLevel' ||
          type === 'withImage') &&
        !reg.test(Number(content))
      ) {
        this.$message.warning('请输入正整数')
        e.target.textContent = 0
        return
      }
      if (
        type === 'companyLevel' ||
        type === 'provinceLevel' ||
        type === 'groupLevel' ||
        type === 'withImage'
      ) {
        scope.row[type] = parseInt(content, 10)
      } else {
        scope.row[type] = content
      }
    },
    getRulers() {
      let status = true
      if (
        _.some(this.tableData, (item) => {
          return item.categoryId === ''
        })
      ) {
        this.$message.warning('稿件类别不能为空')
        status = false
      }
      if (
        _.some(this.tableData, (item) => {
          return item.typeId === ''
        })
      ) {
        this.$message.warning('稿件类型不能为空')
        status = false
      }
      return status
    },
    getFocus(e, row, type) {},
    isEdit() {
      this.canEdit = false
      this.tableData.length === 0 ? this.addData() : ''
    },
    removeRow(index, rows, item) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.deleteList.push(item.id)
        rows.splice(index, 1)
        this.$message({
          type: 'success',
          message: '删除成功!',
        })
      })
    },
    async submit() {
      if (this.getRulers() === false) {
        return
      }
      const [err, res] = await royaltiesStandardApi.updateRoyaltiesStandard({
        body: this.tableData,
      })
      const [deleteErr, deleteRes] = await royaltiesStandardApi.deleteRoyaltiesStandard({
        body: _.compact(this.deleteList),
      })

      if (!err && res && !deleteErr && deleteRes) {
        this.$message.success('保存成功')
        this.cancel()
      }
    },
    cancel() {
      this.canEdit = true
      this.getTableData()
    },
    addData() {
      const param = {
        id: null,
        categoryId: '',
        typeId: '',
        companyLevel: 0,
        provinceLevel: 0,
        groupLevel: 0,
        withImage: 0,
        remark: '',
      }
      this.tableData.push(param)
    },
  },
}
</script>

<style lang="scss" scoped></style>
